import { CombinedReducers } from 'app_events/index'
import React, { FC, useState } from 'react'
import { Accordion, Card } from 'react-bootstrap'
import { AiOutlineCloseCircle, AiOutlinePlusCircle } from 'react-icons/ai'
import { useSelector } from 'react-redux'
import "./StudentDashboardCourseCriteria.scss"
import { HiDownload } from "react-icons/hi";
import StudentDashboardApprovalCriteria from '../StudentDashboardApprovalCriteria/StudentDashboardApprovalCriteria'

interface IStudentDashboardCourseCriteriaProps {
  id?: string
  toggleId?: string
}

const StudentDashboardCourseCriteria: FC<IStudentDashboardCourseCriteriaProps> = ({
  id,
  toggleId,
}) => {
  const { courseSelected } = useSelector((state: CombinedReducers) => state.courses)
  const [activeKey, setActiveKey] = useState<string | undefined>(undefined)

  const renderIcon = () => {
    if (activeKey) {
      return (<AiOutlineCloseCircle size={25} />)
    }
    return (<AiOutlinePlusCircle size={25} />)
  }

  const handleOnSelect = (e: any) => {
    setActiveKey(e)
  }

  return (
    <div id={id} className="student-dashboard-course-criteria--layout">
      <Accordion activeKey={activeKey} onSelect={handleOnSelect}>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Card.Header} id={toggleId} eventKey={'0'}>
              <div>Ver criterios</div>
              <div className='icon'>
                {renderIcon()}
              </div>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              {courseSelected?.certificateCriteriaUrl && (
                <a href={courseSelected?.certificateCriteriaUrl} target='blank' referrerPolicy='noreferrer' style={{ color: 'var(--gray-600)' }}>
                  <HiDownload fontSize="20px" /> &nbsp; &nbsp;
                  <span style={{ textDecoration: 'underline' }}>
                    Criterios de certificación
                  </span>
                </a>
              )}
              {courseSelected?.specialServiceConditionsUrl && (
                <a href={courseSelected?.specialServiceConditionsUrl} target='blank' referrerPolicy='noreferrer' style={{ color: 'var(--gray-600)' }}>
                  <HiDownload fontSize="20px" /> &nbsp; &nbsp;
                  <span style={{ textDecoration: 'underline' }}>
                    Condiciones especiales del servicio
                  </span>
                </a>
              )}
              {!!courseSelected && (
                <StudentDashboardApprovalCriteria courseScheduling={courseSelected} />
              )}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  )
}

export default StudentDashboardCourseCriteria
